import { FormattedMessage } from '../../../modules/taboola-common-frontend-modules/i18n';

export const getItemCaption = item => {
    const { caption, captionComponent: CaptionComponent } = item;
    const captionContent = CaptionComponent ? (
        <CaptionComponent />
    ) : (
        <FormattedMessage id={caption.id} defaultMessage={caption.default} />
    );

    return captionContent;
};
